import { lazy } from 'react';

const Home = lazy(() => import('./home'));
const Taxes = lazy(() => import('./taxes'));
const Summary = lazy(() => import('./summary'));

export { Home, Taxes, Summary };
